import { Instagram, Youtube, Facebook, ArrowUp } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId, scrollToTop } from "../lib/scroll";

const SpotifyIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" {...props}>
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" />
  </svg>
);

const SOCIALS = [
  { id: "instagram", label: "Instagram", icon: Instagram, href: "https://www.instagram.com/cuartobolero_oficial/" },
  { id: "youtube", label: "YouTube", icon: Youtube, href: "https://www.youtube.com/@cuartobolero66" },
  { id: "facebook", label: "Facebook", icon: Facebook, href: "https://www.facebook.com/cuartobolero.talavera/" },
  { id: "spotify", label: "Spotify", icon: SpotifyIcon, href: "https://open.spotify.com/search/cuarto%20bolero" },
];

export const Footer = () => (
  <footer id="contacto" className="relative pt-24 sm:pt-32 pb-10 border-t border-gold/10">
    <div className="mx-auto max-w-[1600px] px-6 sm:px-12 lg:px-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <Reveal>
            <p className="eyebrow">Contacto</p>
            <h2 className="mt-5 font-serif text-4xl md:text-5xl text-cream leading-tight">
              ¿Hablamos? <span className="italic text-gold">Cuéntanos tu evento.</span>
            </h2>
            <a
              data-testid="footer-email-link"
              href="mailto:eventos@produccionessibemol.es"
              className="mt-8 inline-block font-serif text-2xl md:text-3xl text-cream underline decoration-gold/40 underline-offset-8 hover:text-gold transition-colors"
            >
              eventos@produccionessibemol.es
            </a>
            <p className="mt-4 text-sm text-sand">Agencia de management: Producciones SiBemol · <a data-testid="footer-phone-link" href="tel:+34618551512" className="hover:text-gold transition-colors">618 551 512</a></p>
          </Reveal>
        </div>
        <div className="md:col-span-6 flex md:justify-end">
          <Reveal delay={0.1}>
            <div className="flex flex-wrap gap-4" data-testid="footer-socials">
              {SOCIALS.map((s) => {
                const Icon = s.icon;
                return (
                  <a
                    key={s.id}
                    data-testid={`footer-social-${s.id}`}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-cream/20 text-sand transition-all duration-300 hover:border-gold hover:text-gold hover:-translate-y-1"
                  >
                    <Icon size={18} strokeWidth={1.5} />
                  </a>
                );
              })}
            </div>
            <p className="mt-6 text-sm text-mute max-w-xs">
              Síguenos para fechas, directos y nuevas canciones.
            </p>
            <button
              data-testid="footer-nav-concerts"
              onClick={() => scrollToId("conciertos")}
              className="mt-8 inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.2em] text-gold hover:text-cream transition-colors"
            >
              Ver próximos conciertos →
            </button>
          </Reveal>
        </div>
      </div>

      <div className="mt-20 select-none" aria-hidden="true">
        <p className="font-sans leading-none text-center text-[clamp(2.6rem,10vw,9rem)] tracking-tight whitespace-nowrap overflow-hidden" data-testid="footer-wordmark">
          <span className="font-light text-gold/25">CUARTO</span>
          <span className="font-semibold text-cream/15">BOLERO</span>
        </p>
      </div>

      <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-6 border-t border-cream/10 pt-8">
        <p className="text-[11px] uppercase tracking-[0.25em] text-mute">© {new Date().getFullYear()} Cuarto Bolero · Todos los derechos reservados</p>
        <button
          data-testid="back-to-top-button"
          onClick={scrollToTop}
          aria-label="Volver arriba"
          className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-gold transition-all duration-300 hover:bg-gold hover:text-ink"
        >
          <ArrowUp size={18} strokeWidth={1.5} />
        </button>
      </div>
    </div>
  </footer>
);
